var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { IconButton, Menu as MenuBase, MenuItem as MenuItemBase } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { useLinked } from '@type-r/react';
import * as React from 'react';
var MenuOpen = React.createContext(undefined);
export var Menu = function (_a) {
    var icon = _a.icon, props = __rest(_a, ["icon"]);
    var anchorRef = React.createRef();
    var $open = useLinked(false);
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { ref: anchorRef, onClick: function (e) {
                e.stopPropagation();
                $open.true();
            } }, icon || (React.createElement(IconButton, { "aria-label": "Move to non-ar" },
            React.createElement(MoreVertIcon, { fontSize: "small" })))),
        React.createElement(MenuOpen.Provider, { value: $open },
            React.createElement(MenuBase, __assign({}, props, { anchorEl: function () { return anchorRef.current; }, open: $open.value, onBackdropClick: function (e) { return e.stopPropagation(); }, onClose: $open.false }), props.children))));
};
export var MenuItem = function (_a) {
    var onSelect = _a.onSelect, props = __rest(_a, ["onSelect"]);
    var $open = React.useContext(MenuOpen);
    return (React.createElement(MenuItemBase, __assign({}, props, { onClick: function () {
            if ($open) {
                $open.set(false);
            }
            if (onSelect) {
                onSelect();
            }
        } }), props.children));
};
//# sourceMappingURL=menu.js.map